import {$controller} from "rapid/index";

import {cloneDeep, kebabCase, isEqual} from "lodash";
import {countries} from "../../common/address/countries";
import {FILE_SIZES} from "../../../constants/file-sizes.constant";

const dependencies = ["$Deployment", "$companies", "$BoothList","$Configuration", "$resource"];

class DeploymentUpdateController extends $controller {

    constructor($injector, $stateParams, $scope, $element, $ToastService, $resource, $q) {
        "ngInject";
        super($injector, dependencies);
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$element = $element;
        this.toastService = $ToastService;
        this.multiConfigResource = $resource("/api/configurations/:id/multi-config/", null, {update: {method: "PUT"}});
        this.deploymentMultiConfigResource = $resource("/api/deployments/:id/multi-config/", null, {update: {method: "PUT"}});
        this.$resource = $resource;
        this.$q = $q;
        this.isNew = this.$stateParams.isNew;
        this.company = this.$stateParams.company;
        this.companyAttachmentsUrl = null;
        this.copiedDeployment = {};
        const cachedCompany = this.$companies && this.$companies.getCached ? this.$companies.getCached() : null;
        if (cachedCompany) {
            this.updateCompanyAttachmentsUrl({company_info: cachedCompany, company: cachedCompany});
        }
        this.countries = countries;
        this.checkboxConditions = [
            {
                position: 1,
                checked: false
            },
            {
                position: 2,
                checked: false
            },
            {
                position: 3,
                checked: false
            },
            {
                position: 4,
                checked: false
            },
            {
                position: 5,
                checked: false
            }
        ];
        this.configurations = [];
        this.configsList = [];
        this.selectedConfigsList = [];
        this.configsDropdownOpen = {};
        this.searchConfigs = {};
        this.filteredConfigsList = {};
        this.selectedConfigs = {};
        this.selectedConfig = null;
        this.searchTimeout = {};
        this.orientationErrors = {}; // Store orientation errors for each config index
        this.fileSizes = FILE_SIZES; // File size limits for uploads
        // Оновлюємо URI аплоада, якщо компанія підвантажиться/зміниться асинхронно
        this.$scope.$watch(
            () => this.deployment && (this.deployment.company_info || this.deployment.company),
            () => {
                if (this.deployment) {
                    this.updateCompanyAttachmentsUrl(this.deployment);
                }
            }
        );

        this.status = {
            "draft": "Draft",
            "booked": "Booked",
            "delivery": "Delivery",
            "active": "Active",
            "done": "Done"
        };

        this.resolutionOptions = [
            { group: "Common Resolutions" },
            { label: "1080p (1920 × 1080 – Landscape)", width: 1920, height: 1080 },
            { label: "1080p (1080 × 1920 – Portrait)", width: 1080, height: 1920 },
            { label: "4K UHD (3840 × 2160 – Landscape)", width: 3840, height: 2160 },
            { label: "4K UHD (2160 × 3840 – Portrait)", width: 2160, height: 3840 },
            { group: "Tablet Devices" },
            { label: "iPad 10.2\" (2160 × 1620 – Landscape)", width: 2160, height: 1620 },
            { label: "iPad 10.2\" (1620 × 2160 – Portrait)", width: 1620, height: 2160 },
            { label: "Xiaomi (3048 × 2032 – Landscape)", width: 3048, height: 2032 },
            { label: "Xiaomi (2032 × 3048 – Portrait)", width: 2032, height: 3048 },
            { label: "Huawei (2880 × 1920 – Landscape)", width: 2880, height: 1920 },
            { label: "Huawei (1920 × 2880 – Portrait)", width: 1920, height: 2880 },
            { label: "Samsung (2960 × 1848 – Landscape)", width: 2960, height: 1848 },
            { label: "Samsung (1848 × 2960 – Portrait)", width: 1848, height: 2960 }
        ];
        this.selectedResolution = null;
        this.resolutionDropdownOpen = false;
        this.selectResolution = (resolution) => {
            this.selectedResolution = resolution;
            this.resolutionDropdownOpen = false;
            if (!this.deployment.screen) this.deployment.screen = {};
            this.deployment.screen.width = resolution.width;
            this.deployment.screen.height = resolution.height;

            // Ensure multi_config exists and update it with selected resolution
            if (!this.deployment.multi_config) {
                this.deployment.multi_config = {
                    active: false,
                    screen_orientation: this.deployment.screenOrientation || "preselected",
                    screen_width: resolution.width,
                    screen_height: resolution.height,
                    selected_resolution: {
                        label: resolution.label,
                        width: resolution.width,
                        height: resolution.height
                    },
                    background: {
                        attachment_file: null,
                        start_screen_background_mode: "image",
                        start_screen_background_color: "#ffffff",
                        start_screen_image_style: "stretch",
                        start_screen_live_view: false
                    },
                    configurations_info: []
                };
            } else {
                // Update multi_config with selected resolution
                this.deployment.multi_config.screen_width = resolution.width;
                this.deployment.multi_config.screen_height = resolution.height;
                this.deployment.multi_config.selected_resolution = {
                    label: resolution.label,
                    width: resolution.width,
                    height: resolution.height
                };
                // Ensure screenOrientation is set to preselected when selecting a preset
                if (this.deployment.screenOrientation !== "preselected") {
                    this.deployment.screenOrientation = "preselected";
                    this.deployment.multi_config.screen_orientation = "preselected";
                }
            }

            // Re-check all configuration orientations when resolution changes
            this.recheckAllConfigOrientations();
        };

        let deployment;
        if ($stateParams.cid && $stateParams.cid !== "create") {
            deployment = this.$Deployment.get({id: $stateParams.cid});
        } else {
            deployment = this.$Deployment.get({url: this.$companies.getCached().default_configuration});
        }

        deployment && deployment.$promise
            .then((deployment) => {
                if (deployment.configurations) {
                    this.configurations = [...deployment.configurations];
                }
                if (deployment.multi_config && deployment.multi_config.configurations_info) {
                    this.configurations_info = deployment.multi_config.configurations_info.map(ci => ({
                        id: ci.id,
                        url: ci.url,
                        name: ci.name,
                        config_index: ci.config_index
                    }));
                } else if (deployment.configurations_info) {
                    this.configurations_info = [...deployment.configurations_info];
                } else {
                    this.configurations_info = [];
                }
                if (this.$stateParams && this.$stateParams.code && localStorage.getItem("dropboxDeployment")) {
                    this.getDropboxToken();
                } else {
                    this.deployment = deployment;
                }
                this.updateCompanyAttachmentsUrl(deployment);
                deployment.deployment_start = deployment.deployment_start ? moment(deployment.deployment_start)._d : null;
                deployment.deployment_end = deployment.deployment_end ? moment(deployment.deployment_end)._d : null;
                deployment.delivery_start = deployment.delivery_start ? moment(deployment.delivery_start)._d : null;
                deployment.delivery_end = deployment.delivery_end ? moment(deployment.delivery_end)._d : null;
                deployment.collection_start = deployment.collection_start ? moment(deployment.collection_start)._d : null;
                deployment.collection_end = deployment.collection_end ? moment(deployment.collection_end)._d : null;
                if (deployment.local_data_saving === undefined) {
                    deployment.local_data_saving = false;
                }
                if (deployment.only_local_data_saving === undefined) {
                    deployment.only_local_data_saving = false;
                }
                if (deployment.local_data_path === undefined || deployment.local_data_path === null) {
                    deployment.local_data_path = "";
                }
                if (deployment.dropbox_settings) {
                    if (deployment.dropbox_settings.hasOwnProperty("token")) {
                        if (!deployment.dropbox_settings.conditions.checkboxConditions) {
                            deployment.dropbox_settings.conditions.checkboxConditions = this.checkboxConditions;
                        }
                        this.checkboxConditions = deployment.dropbox_settings.conditions.checkboxConditions;
                    }
                }
                // Initialize multi_config with screen orientation settings
                // This object stores all multi-config related settings from radio-group-section
                // It includes: screen_orientation, screen_width, screen_height, selected_resolution
                // This object is part of the deployment and will be saved to the server

                // First, determine screen orientation from multi_config if it exists, otherwise use deployment.screenOrientation
                let screenOrientation = "preselected";
                if (deployment.multi_config && deployment.multi_config.screen_orientation) {
                    screenOrientation = deployment.multi_config.screen_orientation;
                } else if (deployment.screenOrientation) {
                    screenOrientation = deployment.screenOrientation;
                }

                if (!deployment.multi_config) {
                    // Initialize multi_config with screen orientation from deployment
                    deployment.multi_config = {
                        id: null,
                        active: false,
                        screen_orientation: screenOrientation,
                        screen_width: deployment.screen ? deployment.screen.width : (firstOption ? firstOption.width : 1920),
                        screen_height: deployment.screen ? deployment.screen.height : (firstOption ? firstOption.height : 1080),
                        selected_resolution: null, // Will be set after selectedResolution is determined
                        standby_screen: false,
                        standby_screen_activate_time: 30,
                        standby_screen_after_each_session: false,
                        standby_screen_image: {attachment_file: null},
                        show_multi_config_before_first_session: false,
                        background: {
                            url: null,
                            content_object: null,
                            kind: null,
                            is_overlay: false,
                            attachment_file: null,
                            original_name: null,
                            thumbnail_file: null,
                            first_frame: null,
                            first_frame_alpha: null,
                            attachment_file_alpha: null,
                            start_screen_background_mode: "image",
                            start_screen_background_color: "#ffffff",
                            start_screen_image_style: "stretch",
                            start_screen_live_view: false,
                            created: null,
                            modified: null,
                            creator: null,
                            configurations: []
                        },
                        configurations_info: [] // [{id,url,name,config_index,width,height,x,y,custom_icon,angle}]
                    };
                } else {
                    // Ensure multi_config has all required properties
                    if (deployment.multi_config.active === undefined) {
                        deployment.multi_config.active = false;
                    }
                    if (deployment.multi_config.background === undefined || deployment.multi_config.background === null) {
                        const existingBg = deployment.multi_config.background || {};
                        deployment.multi_config.background = {
                            url: existingBg.url || null,
                            content_object: null,
                            kind: null,
                            is_overlay: false,
                            attachment_file: existingBg.attachment_file || null,
                            original_name: null,
                            thumbnail_file: null,
                            first_frame: null,
                            first_frame_alpha: null,
                            attachment_file_alpha: null,
                            start_screen_background_mode: "image",
                            start_screen_background_color: "#ffffff",
                            start_screen_image_style: "stretch",
                            start_screen_live_view: false,
                            created: null,
                            modified: null,
                            creator: null,
                            configurations: []
                        };
                    }
                    if (deployment.multi_config.standby_screen_image === undefined || deployment.multi_config.standby_screen_image === null) {
                        deployment.multi_config.standby_screen_image = {attachment_file: null};
                    }
                    if (deployment.multi_config.configurations_info === undefined) {
                        deployment.multi_config.configurations_info = [];
                    }

                    // Sync configurations_info with existing configs (legacy configList support)
                    const legacyList = deployment.multi_config.configList || deployment.multi_config.config_list;
                    if (legacyList && legacyList.length > 0) {
                        deployment.multi_config.configurations_info = legacyList.map((tp, idx) => ({
                            id: tp.configId || tp.config_id || null,
                            url: tp.configUrl || tp.config_url || null,
                            name: tp.name || null,
                            config_index: tp.configIndex !== undefined ? tp.configIndex : idx,
                            width: tp.width || 25,
                            height: tp.height || 25,
                            x: tp.x || 20 + (idx * 20),
                            y: tp.y || 60,
                            custom_icon: tp.customIcon || tp.custom_icon || null,
                            angle: tp.angle || 0
                        }));
                    }

                    if (deployment.configurations_info && deployment.configurations_info.length > 0) {
                        deployment.configurations_info.forEach((configInfo, index) => {
                            const existing = deployment.multi_config.configurations_info.find(
                                tp => tp.config_index === index || tp.id === configInfo.id || tp.url === configInfo.url
                            );
                            if (!existing) {
                                deployment.multi_config.configurations_info.push({
                                    id: configInfo.id,
                                    url: configInfo.url,
                                    name: configInfo.name,
                                    config_index: index,
                                    width: 25,
                                    height: 25,
                                    x: 20 + (index * 20),
                                    y: 60,
                                    custom_icon: null,
                                    angle: 0
                                });
                            } else {
                                existing.config_index = index;
                                existing.id = existing.id || configInfo.id;
                                existing.url = existing.url || configInfo.url;
                                existing.name = existing.name || configInfo.name;
                            }
                        });
                    }

                    // Update screenOrientation from multi_config (priority)
                    if (deployment.multi_config.screen_orientation) {
                        screenOrientation = deployment.multi_config.screen_orientation;
                        deployment.screenOrientation = screenOrientation;
                    } else if (deployment.screenOrientation) {
                        deployment.multi_config.screen_orientation = deployment.screenOrientation;
                        screenOrientation = deployment.screenOrientation;
                    } else {
                        deployment.multi_config.screen_orientation = "preselected";
                        screenOrientation = "preselected";
                        deployment.screenOrientation = "preselected";
                    }
                }

                // Now initialize screen and selectedResolution based on screen_orientation
                // CRITICAL: This must happen AFTER we've determined the correct screen_orientation
                const firstOption = this.resolutionOptions.find(opt => !opt.group);

                if (screenOrientation === "custom") {
                    // For custom mode: load dimensions from multi_config, clear selectedResolution
                    this.selectedResolution = null;

                    if (!deployment.screen) {
                        deployment.screen = {};
                    }

                    // Load dimensions from multi_config if they exist
                    if (deployment.multi_config && deployment.multi_config.screen_width && deployment.multi_config.screen_height) {
                        deployment.screen.width = deployment.multi_config.screen_width;
                        deployment.screen.height = deployment.multi_config.screen_height;
                    } else if (!deployment.screen.width || !deployment.screen.height) {
                        // Fallback to defaults if no dimensions in multi_config
                        deployment.screen.width = deployment.screen.width || 1920;
                        deployment.screen.height = deployment.screen.height || 1080;
                    }
                } else {
                    // For preselected mode: try to find resolution in options
                    if (!deployment.screen || !deployment.screen.width || !deployment.screen.height) {
                        // If no screen dimensions, use first option or multi_config values
                        if (deployment.multi_config && deployment.multi_config.screen_width && deployment.multi_config.screen_height) {
                            deployment.screen = {
                                width: deployment.multi_config.screen_width,
                                height: deployment.multi_config.screen_height
                            };
                            // Try to find matching resolution
                            const found = this.resolutionOptions.find(opt =>
                                !opt.group &&
                                opt.width === deployment.multi_config.screen_width &&
                                opt.height === deployment.multi_config.screen_height
                            );
                            if (found) {
                                this.selectedResolution = found;
                            } else if (firstOption) {
                                this.selectedResolution = firstOption;
                                deployment.screen.width = firstOption.width;
                                deployment.screen.height = firstOption.height;
                            }
                        } else if (firstOption) {
                            deployment.screen = {
                                width: firstOption.width,
                                height: firstOption.height
                            };
                            this.selectedResolution = firstOption;
                        }
                    } else {
                        // Screen dimensions exist, try to find matching resolution
                        const found = this.resolutionOptions.find(opt =>
                            !opt.group &&
                            opt.width === deployment.screen.width &&
                            opt.height === deployment.screen.height
                        );
                        if (found) {
                            this.selectedResolution = found;
                        }
                    }

                    // Restore selected_resolution from multi_config if it exists and matches
                    if (deployment.multi_config && deployment.multi_config.selected_resolution && !this.selectedResolution) {
                        const foundResolution = this.resolutionOptions.find(opt =>
                            !opt.group &&
                            opt.width === deployment.multi_config.selected_resolution.width &&
                            opt.height === deployment.multi_config.selected_resolution.height
                        );
                        if (foundResolution) {
                            this.selectedResolution = foundResolution;
                            if (!deployment.screen) deployment.screen = {};
                            deployment.screen.width = foundResolution.width;
                            deployment.screen.height = foundResolution.height;
                        }
                    }

                    // Update multi_config.selected_resolution based on selectedResolution
                    if (screenOrientation === "preselected" && this.selectedResolution) {
                        deployment.multi_config.selected_resolution = {
                            label: this.selectedResolution.label,
                            width: this.selectedResolution.width,
                            height: this.selectedResolution.height
                        };
                    } else if (screenOrientation === "custom") {
                        deployment.multi_config.selected_resolution = null;
                    }
                }

                // Ensure screenOrientation is synced with multi_config (final sync)
                if (deployment.multi_config) {
                    deployment.multi_config.screen_orientation = screenOrientation;
                    deployment.screenOrientation = screenOrientation;
                }
                if (deployment.multi_config) {
                    if (deployment.multi_config.show_multi_config_before_first_session === undefined) {
                        if (deployment.show_multi_config_before_first_session !== undefined) {
                            deployment.multi_config.show_multi_config_before_first_session =
                                !!deployment.show_multi_config_before_first_session;
                        } else if (deployment.multi_config.showMultiConfigBeforeFirstSession !== undefined) {
                            deployment.multi_config.show_multi_config_before_first_session =
                                !!deployment.multi_config.showMultiConfigBeforeFirstSession;
                        } else {
                            deployment.multi_config.show_multi_config_before_first_session = false;
                        }
                    }
                    delete deployment.show_multi_config_before_first_session;
                    delete deployment.showMultiConfigBeforeFirstSession;
                }
                // Зберігаємо початковий стан multi_config для відстеження змін
                this.initialMultiConfig = cloneDeep(deployment.multi_config || null);

                // Initialize configs after deployment data is loaded
                // This ensures configurations_info is available when getConfigs processes it
                this.getConfigs();
            }).catch((e) => {
                console.log(e);
                this.$state.go("deployments");
            });
            // Also get configs list initially (in case deployment is not loaded yet)
            this.getConfigs();
    }

    updateCompanyAttachmentsUrl(deployment) {
        const companyUrl = this.extractCompanyUrl(deployment);
        if (!companyUrl) {
            this.companyAttachmentsUrl = null;
            return;
        }
        const normalizedCompanyUrl = companyUrl.endsWith("/") ? companyUrl : `${companyUrl}/`;
        this.companyAttachmentsUrl = `${normalizedCompanyUrl}attachments/`;
    }

    extractCompanyUrl(deployment) {
        if (!deployment) return null;

        const companyInfo = deployment.company_info;
        if (companyInfo) {
            if (typeof companyInfo === "object" && companyInfo.url) {
                return companyInfo.url;
            }
            if (typeof companyInfo === "string" && companyInfo.length) {
                return companyInfo;
            }
        }

        const company = deployment.company;
        if (company) {
            if (typeof company === "object" && company.url) {
                return company.url;
            }
            if (typeof company === "string" && company.length) {
                return company;
            }
        }

        const cachedCompany = this.$companies && this.$companies.getCached ? this.$companies.getCached() : null;
        if (cachedCompany && cachedCompany.url) {
            return cachedCompany.url;
        }

        return null;
    }

    copyDeployment() {
        let url = cloneDeep(this.deployment.url);
        let uris = cloneDeep(this.deployment.uris);
        let secret_id = cloneDeep(this.deployment.secret_id);
        let name = cloneDeep(this.deployment.name);
        this.deployment = cloneDeep(this.copiedDeployment);
        this.deployment.url = url;
        this.deployment.uris = uris;
        this.deployment.secret_id = secret_id;
        this.deployment.name = name;
        this.updateCompanyAttachmentsUrl(this.deployment);
    }

    connectToDropbox() {
        localStorage.setItem("dropboxDeployment", JSON.stringify(this.deployment));
        let redirect = (process.env.DEVSERVER_PROXY_TARGET ? process.env.DEVSERVER_PROXY_TARGET : "http://localhost:3000") + "/app/deployments/";
        let dropboxToken = (process.env.DROPBOX_CLIENT_ID ? process.env.DROPBOX_CLIENT_ID : "lu4nbb05gj1922c");
        window.location.href = `https://www.dropbox.com/oauth2/authorize?client_id=${dropboxToken}&redirect_uri=${redirect}&response_type=code&force_reauthentication=true&token_access_type=offline`;
    }

    getDropboxToken() {
        this.$auth.$http({
            url: "/api/dropbox/token",
            method: "POST",
            data: {code: this.$stateParams.code}
        }).then((resp) => {
            let d = localStorage.getItem("dropboxDeployment");
            d = JSON.parse(d);
            if (d.local_data_saving === undefined) {
                d.local_data_saving = false;
            }
            if (d.only_local_data_saving === undefined) {
                d.only_local_data_saving = false;
            }
            if (d.local_data_path === undefined || d.local_data_path === null) {
                d.local_data_path = "";
            }
            this.deployment = d;
            this.updateCompanyAttachmentsUrl(this.deployment);
            this.deployment.dropbox_settings = {
                token: resp.data.access_token,
                refresh_token: resp.data.refresh_token,
                folder: `/upreach/${kebabCase(this.deployment.name)}`,
                outputTypes: {
                    printing: true,
                    sharing: true,
                    original: true
                },
                captureModes: {
                    photo: true,
                    gif: true,
                    boomerang: true,
                    video: true
                },
                conditions: {
                    dataPrivacyPopupAccepted: false,
                    consentScreenConfirmed: false,
                    dataFormWasSigned: false,
                    checkboxConditions: this.checkboxConditions
                }
            };
            localStorage.removeItem("dropboxDeployment");
        }).catch((err) => {
            console.log(err);
            this.$state.go("deployments");
        });
    }

    disconnectFromDropbox() {
        let confirm = this.$mdDialog.confirm()
            .title("Disconnect from Dropbox?")
            .textContent("This disconnects the Deployment " + this.deployment.name +" from your Dropbox account. ")
            .ok("YES")
            .cancel("NO");
        this.$mdDialog.show(confirm).then(() => {
            this.deployment.dropbox_settings = {};
        });
    }
    setCheckboxConditionValue (value) {
        if (value) {
            this.checkboxConditions.forEach(el=>{
                el.checked = false;
            });
        }
    }

    saveDeployment() {
        if (this.deployment.booth === "No value") {
            this.deployment.booth = null;
        }
        const deploymentId = this.deployment.id || this.deployment.pk || this.$stateParams.cid
            || (this.deployment.url ? this.deployment.url.replace(/\/$/, "").split("/").pop() : null);
        // Update deployment configurations array before saving
        if (this.configurations) {
            // Filter out null values (empty slots)
            this.deployment.configurations = this.configurations.filter(config => config !== null && config !== undefined);
        }

        // Ensure multi_config object exists and is properly initialized
        if (!this.deployment.multi_config) {
            this.deployment.multi_config = {
                active: false,
                screen_orientation: this.deployment.screenOrientation || "preselected",
                screen_width: this.deployment.screen ? this.deployment.screen.width : 1920,
                screen_height: this.deployment.screen ? this.deployment.screen.height : 1080,
                selected_resolution: null,
                standby_screen: false,
                standby_screen_activate_time: 30,
                standby_screen_after_each_session: false,
                standby_screen_image: null,
                show_multi_config_before_first_session: false,
                background: {
                    attachment_file: null,
                    start_screen_background_mode: "image",
                    start_screen_background_color: "#ffffff",
                    start_screen_image_style: "stretch",
                    start_screen_live_view: false
                },
                configurations_info: []
            };
        }
        if (this.deployment.multi_config.show_multi_config_before_first_session === undefined) {
            if (this.deployment.show_multi_config_before_first_session !== undefined) {
                this.deployment.multi_config.show_multi_config_before_first_session =
                    !!this.deployment.show_multi_config_before_first_session;
            } else if (this.deployment.multi_config.showMultiConfigBeforeFirstSession !== undefined) {
                this.deployment.multi_config.show_multi_config_before_first_session =
                    !!this.deployment.multi_config.showMultiConfigBeforeFirstSession;
            } else {
                this.deployment.multi_config.show_multi_config_before_first_session = false;
            }
        }
        delete this.deployment.show_multi_config_before_first_session;
        delete this.deployment.showMultiConfigBeforeFirstSession;

        // Sync all settings from radio-group-section to multi_config before saving
        // Sync screenOrientation from deployment to multi_config
        if (this.deployment.screenOrientation) {
            this.deployment.multi_config.screen_orientation = this.deployment.screenOrientation;
        }

        // Sync screen dimensions from deployment.screen to multi_config
        // This is critical for Custom Resolution to work properly
        if (this.deployment.screenOrientation === "custom") {
            // For custom mode, ensure screen object exists and sync to multi_config
            if (!this.deployment.screen) {
                this.deployment.screen = {};
            }
            // Ensure multi_config has the latest values from screen inputs
            if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
                this.deployment.multi_config.screen_width = this.deployment.screen.width;
            }
            if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
                this.deployment.multi_config.screen_height = this.deployment.screen.height;
            }
            // Clear selected_resolution for custom mode
            this.deployment.multi_config.selected_resolution = null;
        } else if (this.deployment.screen) {
            // For preselected mode, also sync screen dimensions if they exist
            if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
                this.deployment.multi_config.screen_width = this.deployment.screen.width;
            }
            if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
                this.deployment.multi_config.screen_height = this.deployment.screen.height;
            }
        }

        // Sync selected_resolution if preselected mode
        if (this.deployment.multi_config.screen_orientation === "preselected" && this.selectedResolution) {
            this.deployment.multi_config.selected_resolution = {
                label: this.selectedResolution.label,
                width: this.selectedResolution.width,
                height: this.selectedResolution.height
            };
        }

        // Sync configurations_info into multi_config before save
        if (this.deployment.multi_config) {
            if (!this.deployment.multi_config.configurations_info) {
                this.deployment.multi_config.configurations_info = [];
            }
            // Align indices and merge metadata from configurations_info list
            const total = this.configurations ? this.configurations.length : 0;
            const resultList = [];
            for (let i = 0; i < total; i++) {
                const info = this.configurations_info ? this.configurations_info[i] : null;
                // Get current touch point (may have been updated via UI)
                const currentTouchPoint = this.getConfigTouchPoint(i);
                const existing = this.deployment.multi_config.configurations_info.find(ci => ci.config_index === i) || {};

                // Sync custom_icon from current touch point or existing, prefer customIcon alias
                let customIcon = null;
                if (currentTouchPoint) {
                    customIcon = currentTouchPoint.custom_icon || currentTouchPoint.customIcon || null;
                } else {
                    customIcon = existing.custom_icon || existing.customIcon || null;
                }

                resultList.push({
                    id: info ? info.id : existing.id || null,
                    url: info ? info.url : existing.url || null,
                    name: info ? info.name : existing.name || null,
                    config_index: i,
                    width: currentTouchPoint ? (currentTouchPoint.width || existing.width || 25) : (existing.width || 25),
                    height: currentTouchPoint ? (currentTouchPoint.height || existing.height || 25) : (existing.height || 25),
                    x: currentTouchPoint ? (currentTouchPoint.x || existing.x || (20 + (i * 20))) : (existing.x || (20 + (i * 20))),
                    y: currentTouchPoint ? (currentTouchPoint.y || existing.y || 60) : (existing.y || 60),
                    custom_icon: customIcon,
                    customIcon: customIcon, // Keep alias in sync
                    angle: currentTouchPoint ? (currentTouchPoint.angle || existing.angle || 0) : (existing.angle || 0)
                });
            }
            this.deployment.multi_config.configurations_info = resultList;
        }

        // Persist each multi_config configuration touch point before saving deployment
        const saveMultiConfigPromises = [];
        if (this.deployment.multi_config && this.deployment.multi_config.configurations_info && deploymentId) {
            this.deployment.multi_config.configurations_info.forEach((tp) => {
                if (!tp || !tp.id) return;
                const showFirst = this.deployment.multi_config.show_multi_config_before_first_session !== undefined
                    ? !!this.deployment.multi_config.show_multi_config_before_first_session : false;
                const payload = {
                    deployment: deploymentId,
                    config_index: tp.config_index,
                    width: tp.width,
                    height: tp.height,
                    x: tp.x,
                    y: tp.y,
                    angle: tp.angle,
                    custom_icon: this.getAttachmentPk(tp.custom_icon),
                    show_multi_config_before_first_session: showFirst
                };
                const action = this.multiConfigResource && this.multiConfigResource.update ? "update" : "save";
                saveMultiConfigPromises.push(this.multiConfigResource[action]({id: tp.id}, payload).$promise);
            });
        }
        // After touch points: save deployment multi_config, then deployment (strict order; no .finally — it could run before PUT finished)
        const isMultiConfigChanged = this.hasMultiConfigChanged();
        this.$q.all(saveMultiConfigPromises)
            .then(() => {
                if (this.deployment.multi_config && deploymentId) {
                    // Ensure screen dimensions are synced before creating payload
                    if (this.deployment.screenOrientation === "custom" && this.deployment.screen) {
                        if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
                            this.deployment.multi_config.screen_width = this.deployment.screen.width;
                        }
                        if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
                            this.deployment.multi_config.screen_height = this.deployment.screen.height;
                        }
                    }

                    const multiConfigPayload = {
                        active: this.deployment.multi_config.active !== undefined ? this.deployment.multi_config.active : false,
                        screen_orientation: this.deployment.multi_config.screen_orientation || "preselected",
                        screen_width: this.deployment.multi_config.screen_width !== undefined && this.deployment.multi_config.screen_width !== null
                            ? this.deployment.multi_config.screen_width : 1920,
                        screen_height: this.deployment.multi_config.screen_height !== undefined && this.deployment.multi_config.screen_height !== null
                            ? this.deployment.multi_config.screen_height : 1080,
                        selected_resolution: this.deployment.multi_config.selected_resolution || null,
                        show_multi_config_before_first_session: this.deployment.multi_config.show_multi_config_before_first_session !== undefined
                            ? this.deployment.multi_config.show_multi_config_before_first_session : false,
                        standby_screen: this.deployment.multi_config.standby_screen !== undefined ? this.deployment.multi_config.standby_screen : false,
                        standby_screen_activate_time: this.deployment.multi_config.standby_screen_activate_time !== undefined
                            ? this.deployment.multi_config.standby_screen_activate_time : 30,
                        standby_screen_after_each_session: this.deployment.multi_config.standby_screen_after_each_session !== undefined
                            ? this.deployment.multi_config.standby_screen_after_each_session : false,
                        standby_screen_image: this.getAttachmentPk(this.deployment.multi_config.standby_screen_image),
                        background: this.getAttachmentPk(this.deployment.multi_config.background)
                    };

                    const action = this.deploymentMultiConfigResource && this.deploymentMultiConfigResource.update ? "update" : "save";
                    return this.deploymentMultiConfigResource[action]({id: deploymentId}, multiConfigPayload).$promise;
                }
                return this.$q.resolve();
            })
            .then(() => this.$Deployment.update(this.deployment).$promise)
            .then(() => {
                if (isMultiConfigChanged) {
                    this.initialMultiConfig = cloneDeep(this.deployment.multi_config || null);
                }
                this.toastService.showSimple(`Deployment saved!`, 5000);
                this.$state.go("deployments");
            })
            .catch((error) => {
                if (error && error.data && error.data.booth) {
                    this.$mdDialog.show(
                        this.$mdDialog.alert()
                            .clickOutsideToClose(true)
                            .title(this.gettext("Error"))
                            .htmlContent(this.gettext("Selected booth is already assigned to another deployment."))
                            .ariaLabel(this.gettext("Error"))
                            .ok("OK")
                    );
                } else {
                    const msg = (error && error.data && (error.data.detail || error.data.message))
                        ? String(error.data.detail || error.data.message)
                        : "";
                    this.toastService.showError(
                        msg ? `${this.gettext("Could not save deployment.")} ${msg}` : this.gettext("Could not save deployment."),
                        8000
                    );
                }
            });
    }
    hasMultiConfigChanged() {
        if (typeof this.initialMultiConfig === "undefined") {
            return false;
        }
        return !isEqual(this.initialMultiConfig || null, this.deployment ? (this.deployment.multi_config || null) : null);
    }
    onOrientationChange(){
        console.log("onOrientationChange=>",this.deployment.multi_config);
    }
    changeLayoutSize(){
        console.log("change size=>",this.deployment.multi_config.screen_height,this.deployment.multi_config.screen_width);
    }
    getLayoutMinSize() {
        //console.log("getLayoutMinSize");
    }
    onStandbyUpload() {
        const img = this.deployment && this.deployment.multi_config ? this.deployment.multi_config.standby_screen_image : null;
        console.log("Standby upload callback", img);
    }
    changeStandByScreenState(enabled) {
        if (!this.deployment || !this.deployment.multi_config) return;
        // Тогл standby_screen відповідає тільки за свій boolean‑стан.
        // Не очищаємо standby_screen_image при вимкненні, щоб не губити завантажений файл.
        if (enabled && !this.deployment.multi_config.standby_screen_image) {
            this.deployment.multi_config.standby_screen_image = {attachment_file: null};
        }
    }
    clearStandbyScreenImage() {
        if (!this.deployment || !this.deployment.multi_config) return;
        // Повністю очищаємо об'єкт standby_screen_image, щоб бекенд не отримував старий attachment
        this.deployment.multi_config.standby_screen_image = null;
    }
    clearMultiConfigBackground() {
        if (!this.deployment || !this.deployment.multi_config) return;
        // Повністю очищаємо background, щоб getAttachmentPk не тягнув старий url/id
        this.deployment.multi_config.background = null;
    }
    onScreenOrientationChange() {
        // Ensure multi_config exists
        if (!this.deployment.multi_config) {
            this.deployment.multi_config = {
                active: false,
                screen_orientation: this.deployment.screenOrientation || "preselected",
                screen_width: this.deployment.screen ? this.deployment.screen.width : 1920,
                screen_height: this.deployment.screen ? this.deployment.screen.height : 1080,
                selected_resolution: null,
                background: null,
                configurations_info: []
            };
        }

        // Update multi_config with screen orientation from radio-group-section
        this.deployment.multi_config.screen_orientation = this.deployment.screenOrientation;

        if (this.deployment.screenOrientation === "preselected" && this.selectedResolution) {
            if (!this.deployment.screen) this.deployment.screen = {};
            this.deployment.screen.width = this.selectedResolution.width;
            this.deployment.screen.height = this.selectedResolution.height;

            // Update multi_config with preselected resolution
            this.deployment.multi_config.screen_width = this.selectedResolution.width;
            this.deployment.multi_config.screen_height = this.selectedResolution.height;
            this.deployment.multi_config.selected_resolution = {
                label: this.selectedResolution.label,
                width: this.selectedResolution.width,
                height: this.selectedResolution.height
            };
        } else if (this.deployment.screenOrientation === "custom") {
            // For custom, sync from screen object
            if (this.deployment.screen) {
                this.deployment.multi_config.screen_width = this.deployment.screen.width || this.deployment.multi_config.screen_width;
                this.deployment.multi_config.screen_height = this.deployment.screen.height || this.deployment.multi_config.screen_height;
            }
            this.deployment.multi_config.selected_resolution = null;
        }

        // Re-check all configuration orientations when screen orientation changes
        this.recheckAllConfigOrientations();
    }

    onScreenSizeChange() {
        // Ensure multi_config exists
        if (!this.deployment.multi_config) {
            this.deployment.multi_config = {
                active: false,
                screen_orientation: this.deployment.screenOrientation || "preselected",
                screen_width: this.deployment.screen ? this.deployment.screen.width : 1920,
                screen_height: this.deployment.screen ? this.deployment.screen.height : 1080,
                selected_resolution: null,
                background: null,
                configurations_info: []
            };
        }

        // Ensure screen object exists
        if (!this.deployment.screen) {
            this.deployment.screen = {};
        }

        // Sync screen width/height changes to multi_config
        // Use !== undefined && !== null to allow 0 values
        if (this.deployment.screenOrientation === "custom") {
            if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null) {
                this.deployment.multi_config.screen_width = this.deployment.screen.width;
            }
            if (this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
                this.deployment.multi_config.screen_height = this.deployment.screen.height;
            }
            // Clear selected_resolution for custom mode
            this.deployment.multi_config.selected_resolution = null;
        } else if (this.deployment.screen.width !== undefined && this.deployment.screen.width !== null &&
                   this.deployment.screen.height !== undefined && this.deployment.screen.height !== null) {
            // For preselected mode, also sync if screen dimensions are explicitly set
            this.deployment.multi_config.screen_width = this.deployment.screen.width;
            this.deployment.multi_config.screen_height = this.deployment.screen.height;
        }

        // Re-check all configuration orientations when screen size changes
        this.recheckAllConfigOrientations();
    }

    /**
     * Re-check orientation for all selected configurations
     */
    recheckAllConfigOrientations() {
        if (!this.selectedConfigsList || !this.configurations_info) {
            return;
        }

        // Check each selected configuration
        this.selectedConfigsList.forEach((config, index) => {
            if (config && this.configurations_info[index]) {
                // Re-check orientation for this config
                this.checkConfigOrientation(config, index);
            }
        });
    }

    getConfigs(search = "") {
        let configs = null;
        configs = this.$Configuration.query({ordering: "name", search: search});
        configs.$promise.then((resp) => {
            this.configsList = resp;

            // Initialize configurations array from configurations_info if it exists
            if (this.configurations_info && this.configurations_info.length > 0) {
                // Ensure configurations array matches configurations_info
                if (!this.configurations || this.configurations.length !== this.configurations_info.length) {
                    this.configurations = this.configurations_info.map(configInfo => configInfo.url);
                }

                // Initialize selectedConfigsList from configurations_info
                this.configurations_info.forEach((configInfo, index) => {
                    // Try to find matching config in configsList
                    const foundConfig = this.configsList.find(config => config.url === configInfo.url || config.id === configInfo.id);
                    if (foundConfig) {
                        this.selectedConfigsList[index] = foundConfig;
                        // Check orientation for loaded configurations
                        this.checkConfigOrientation(foundConfig, index);
                    } else {
                        // If not found in list, create a temporary object from configInfo
                        this.selectedConfigsList[index] = {
                            id: configInfo.id,
                            url: configInfo.url,
                            name: configInfo.name
                        };
                        // Still check orientation even if config not in list
                        this.checkConfigOrientation(this.selectedConfigsList[index], index);
                    }
                    // Initialize filtered list for this dropdown
                    this.filteredConfigsList[index] = [...this.configsList];
                });
            } else {
                // Initialize filtered list for each dropdown
                if (this.configurations) {
                    this.configurations.forEach((configId, index) => {
                        // Initialize filtered list for this dropdown
                        if (!this.filteredConfigsList[index] || this.filteredConfigsList[index].length === 0) {
                            this.filteredConfigsList[index] = [...this.configsList];
                        }
                        // Try to find matching config if configId is not null
                        if (configId) {
                            this.configsList.forEach(config => {
                                if (config.url === configId) {
                                    this.selectedConfigsList[index] = config;
                                }
                            });
                        }
                    });
                }
            }

            // Ensure all existing configuration indices have filtered lists initialized
            if (this.configurations) {
                this.configurations.forEach((configId, index) => {
                    if (!this.filteredConfigsList[index]) {
                        this.filteredConfigsList[index] = [...this.configsList];
                    }
                });
            }
        });
    }

    searchConfigurations(index) {
        const searchTerm = this.searchConfigs[index] ? this.searchConfigs[index].toLowerCase() : "";

        // Clear previous timeout
        if (this.searchTimeout[index]) {
            clearTimeout(this.searchTimeout[index]);
        }

        // If search term is less than 3 characters, show full list
        if (!searchTerm || searchTerm.length < 3) {
            this.filteredConfigsList[index] = [...this.configsList];
            return;
        }

        // Set new timeout for search
        this.searchTimeout[index] = setTimeout(() => {
            // Use API search
            let configs = this.$Configuration.query({ordering: "name", search: searchTerm});
            configs.$promise.then((resp) => {
                this.filteredConfigsList[index] = resp;
            });
        }, 300); // 300ms debounce
    }

    isConfigSelected(config, currentIndex) {
        if (!config || !config.name) {
            return false;
        }

        // Check already chosen configs (excluding current dropdown)
        const name = config.name;
        const usedInSelected = this.selectedConfigsList &&
            this.selectedConfigsList.some((selected, idx) =>
                idx !== currentIndex && selected && selected.name === name);

        const configsInfo = this.deployment && this.deployment.multi_config && this.deployment.multi_config.configurations_info;
        const usedInInfo = configsInfo &&
            configsInfo.some((info, idx) =>
                idx !== currentIndex && info && info.name === name);

        return !!(usedInSelected || usedInInfo);
    }

    selectConfig(config, index) {
        this.selectedConfigsList[index] = config;
        this.configsDropdownOpen[index] = false;
        this.searchConfigs[index] = ""; // Clear search after selection

        // Update the configurations array with the selected config's URL
        // Ensure arrays
        if (!this.configurations) this.configurations = [];
        if (!this.configurations_info) this.configurations_info = [];
        if (!this.deployment.multi_config) this.deployment.multi_config = {configurations_info: []};
        if (!this.deployment.multi_config.configurations_info) this.deployment.multi_config.configurations_info = [];

        // Update or add the config at the specific index (legacy)
        if (this.configurations[index] !== config.url) {
            this.configurations[index] = config.url;
        }

        // Update configurations_info
        this.configurations_info[index] = {
            id: config.id,
            url: config.url,
            name: config.name
        };

        // Mirror into multi_config.configurations_info
        const existing = this.deployment.multi_config.configurations_info[index] || {};
        this.deployment.multi_config.configurations_info[index] = {
            id: config.id,
            url: config.url,
            name: config.name,
            config_index: index,
            width: existing.width || 25,
            height: existing.height || 25,
            x: existing.x || 20 + (index * 20),
            y: existing.y || 60,
            custom_icon: existing.custom_icon || null,
            angle: existing.angle || 0
        };

        // Persist touch-point data for this config to backend multi-config endpoint
        const touchPoint = this.deployment.multi_config.configurations_info[index];
        const deploymentId = this.deployment.id || this.deployment.pk || this.$stateParams.cid
            || (this.deployment.url ? this.deployment.url.replace(/\/$/, "").split("/").pop() : null);
        if (!deploymentId) {
            console.error("Cannot save multi-config: deployment ID is missing");
            return;
        }
        const showFirst = this.deployment.multi_config && this.deployment.multi_config.show_multi_config_before_first_session !== undefined
            ? !!this.deployment.multi_config.show_multi_config_before_first_session : false;
        const payload = {
            deployment: deploymentId,
            config_index: touchPoint.config_index,
            width: touchPoint.width,
            height: touchPoint.height,
            x: touchPoint.x,
            y: touchPoint.y,
            angle: touchPoint.angle,
            custom_icon: this.getAttachmentPk(touchPoint.custom_icon),
            show_multi_config_before_first_session: showFirst
        };
        // Persist touch-point data for this config to backend multi-config endpoint
        if (!this.multiConfigResource || !this.multiConfigResource.save) {
            // Lazy fallback in case resource was not initialized
            this.multiConfigResource = this.$injector.get("$resource")("/api/configurations/:id/multi-config/");
        }
        if (this.multiConfigResource && this.multiConfigResource.save) {
            this.multiConfigResource.save({id: config.id}, payload);
        }

        // Initialize touch point settings for this config in multi_config
        this.initializeConfigTouchPoint(index, config);

        // Check orientation compatibility
        this.checkConfigOrientation(config, index);
    }

    /**
     * Extract attachment PK/UUID from URL
     * @param {Object|string} attachment - Attachment object with url property or URL string
     * @returns {string|null} UUID/PK or null
     */
    getAttachmentPk(attachment) {
        if (!attachment) return null;

        let url = null;
        if (typeof attachment === "string") {
            url = attachment;
        } else if (attachment.url) {
            url = attachment.url;
        } else if (attachment.id) {
            return attachment.id;
        } else if (attachment.pk) {
            return attachment.pk;
        }

        if (!url) return null;

        // Extract UUID from URL like "/api/attachments/c76adf9a-b863-488f-940f-ce953bad3878/"
        const match = url.match(/\/api\/attachments\/([a-f0-9-]+)\//i);
        if (match && match[1]) {
            return match[1];
        }

        // Fallback: try to extract UUID from any URL format
        const parts = url.split("/").filter(p => p.length > 0);
        const uuidPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i;
        for (let i = parts.length - 1; i >= 0; i--) {
            if (uuidPattern.test(parts[i])) {
                return parts[i];
            }
        }

        return null;
    }

    /**
     * Get deployment orientation based on screen dimensions
     * @returns {string} 'landscape' or 'portrait'
     */
    getDeploymentOrientation() {
        if (!this.deployment || !this.deployment.screen) {
            return null;
        }
        const width = this.deployment.screen.width;
        const height = this.deployment.screen.height;

        if (!width || !height) {
            return null;
        }

        return width > height ? "landscape" : "portrait";
    }

    /**
     * Check if configuration orientation matches deployment orientation
     * @param {Object} config - Configuration object
     * @param {number} index - Index of the configuration in the list
     */
    checkConfigOrientation(config, index) {
        // Clear previous error for this index
        this.orientationErrors[index] = null;

        // Get deployment orientation
        const deploymentOrientation = this.getDeploymentOrientation();

        if (!deploymentOrientation) {
            // Can't check if deployment orientation is not set
            return;
        }

        // Fetch configuration details from API
        const configUrl = config.url;
        if (!configUrl) {
            return;
        }

        // Use $Configuration service to get full config data
        const configResource = this.$Configuration.get({url: configUrl});
        configResource.$promise
            .then((configData) => {
                // Check if config has json.admin.general.screenOrientation (legacy) or screen_orientation (new)
                if (configData.json &&
                    configData.json.admin &&
                    configData.json.admin.general &&
                    (configData.json.admin.general.screenOrientation || configData.json.admin.general.screen_orientation)) {

                    const configOrientation = configData.json.admin.general.screenOrientation || configData.json.admin.general.screen_orientation;

                    // Normalize orientation values (landscape/portrait)
                    const normalizedDeploymentOrientation = deploymentOrientation;
                    const normalizedConfigOrientation = configOrientation === "portrait" ? "portrait" : "landscape";

                    // Check if orientations match
                    if (normalizedDeploymentOrientation !== normalizedConfigOrientation) {
                        // Orientation mismatch - set error
                        this.orientationErrors[index] = {
                            deploymentOrientation: normalizedDeploymentOrientation,
                            configOrientation: normalizedConfigOrientation,
                            configName: config.name
                        };

                        // Show error message
                        const deploymentOrientationText = normalizedDeploymentOrientation === "landscape" ? "landscape" : "portrait";
                        const configOrientationText = normalizedConfigOrientation === "landscape" ? "landscape" : "portrait";

                        this.toastService.showSimple(
                            `Orientation conflict: deployment has ${deploymentOrientationText} orientation, but configuration "${config.name}" has ${configOrientationText} orientation.`,
                            8000
                        );
                    } else {
                        // Orientations match - clear error
                        this.orientationErrors[index] = null;
                    }
                }
            })
            .catch((error) => {
                console.error("Error checking configuration orientation:", error);
                // Don't set error if we can't fetch config data
            });
    }

    /**
     * Get file extension
     * @param {string} file
     * @returns {string}
     */
    getFileType(file) {
        if (!file || typeof file !== "string") {
            return "";
        }
        const cleanFile = file.split("?")[0];
        const parts = cleanFile.split(".");
        return parts.length > 1 ? parts.pop().toLowerCase() : "";
    }

    /**
     * Initialize or get touch point settings for a configuration
     * @param {number} index - Index of the configuration
     * @param {Object} config - Configuration object
     * @returns {Object} Touch point settings object
     */
    initializeConfigTouchPoint(index, config) {
        if (!this.deployment || !this.deployment.multi_config) {
            return null;
        }

        if (!this.deployment.multi_config.configurations_info) {
            this.deployment.multi_config.configurations_info = [];
        }

        // Find existing touch point settings for this config
        let touchPoint = this.deployment.multi_config.configurations_info.find(tp => tp.config_index === index);

        if (!touchPoint) {
            // Initialize default touch point settings
            touchPoint = {
                config_index: index,
                config_id: config.id,
                config_url: config.url,
                width: 25, // Default width in %
                height: 25, // Default height in %
                x: 20 + (index * 20), // Default x position, spaced out
                y: 60, // Default y position
                custom_icon: null, // Thumbnail image (start-screen-area uses model.custom_icon)
                customIcon: null, // compatibility alias for UI components
                angle: 0 // Rotation angle
            };
            this.deployment.multi_config.configurations_info.push(touchPoint);
        } else {
            // Update config reference if changed
            touchPoint.config_id = config.id;
            touchPoint.config_url = config.url;
        }
        // Keep alias in sync (upload component may set customIcon)
        if (touchPoint.customIcon && !touchPoint.custom_icon) {
            touchPoint.custom_icon = touchPoint.customIcon;
        } else {
            touchPoint.customIcon = touchPoint.custom_icon;
        }
        // Mark video icons to help preview render correctly
        const iconUrl = touchPoint.custom_icon && typeof touchPoint.custom_icon === "object"
            ? (touchPoint.custom_icon.attachment_file || touchPoint.custom_icon.thumbnail_file || null)
            : (typeof touchPoint.custom_icon === "string" ? touchPoint.custom_icon : null);
        touchPoint.trueVideo = iconUrl ? /\.(mp4|mov|webm)$/i.test(iconUrl) : false;

        return touchPoint;
    }

    /**
     * Get touch point settings for a configuration by index
     * @param {number} index - Index of the configuration
     * @returns {Object} Touch point settings object
     */
    getConfigTouchPoint(index) {
        if (!this.deployment || !this.deployment.multi_config || !this.deployment.multi_config.configurations_info) {
            return null;
        }

        let touchPoint = this.deployment.multi_config.configurations_info.find(tp => tp.config_index === index);

        if (!touchPoint && this.configurations_info && this.configurations_info[index]) {
            // Initialize if not exists
            const configInfo = this.configurations_info[index];
            touchPoint = this.initializeConfigTouchPoint(index, {
                id: configInfo.id,
                url: configInfo.url,
                name: configInfo.name
            });
        }

        // Ensure customIcon and custom_icon are in sync (upload component may set customIcon)
        if (touchPoint) {
            // Priority: customIcon (set by upload component) > custom_icon
            if (touchPoint.customIcon && touchPoint.customIcon !== touchPoint.custom_icon) {
                touchPoint.custom_icon = touchPoint.customIcon;
            } else if (touchPoint.custom_icon && !touchPoint.customIcon) {
                touchPoint.customIcon = touchPoint.custom_icon;
            }
        }

        return touchPoint;
    }

    /**
     * Get all touch point areas formatted for html-preview component
     * @returns {Object} Object with area keys for html-preview
     */
    getMultiConfigAreas() {
        if (!this.deployment || !this.deployment.multi_config || !this.deployment.multi_config.configurations_info) {
            return {};
        }

        // Convert configurations_info to areas format expected by html-preview
        // html-preview expects an object with keys, not an array
        const areas = {};
        this.deployment.multi_config.configurations_info.forEach((touchPoint) => {
            const areaKey = `config${touchPoint.config_index}`;

            // Process custom icon (support both custom_icon and customIcon coming from upload widget)
            const rawIcon = touchPoint.custom_icon || touchPoint.customIcon || null;
            const iconUrl = rawIcon && typeof rawIcon === "object"
                ? (rawIcon.attachment_file || rawIcon.thumbnail_file || null)
                : (typeof rawIcon === "string" ? rawIcon : null);
            const isVideoIcon = iconUrl ? /\.(mp4|mov|webm)$/i.test(iconUrl) : false;
            // Keep custom_icon even for video (html-preview will render <video/>)
            let custom_icon = null;
            if (rawIcon) {
                if (typeof rawIcon === "object") {
                    if (rawIcon.attachment_file || rawIcon.thumbnail_file) {
                        custom_icon = rawIcon;
                    }
                } else if (typeof rawIcon === "string" && rawIcon.length > 0) {
                    custom_icon = {attachment_file: rawIcon};
                }
            }

            areas[areaKey] = {
                width: touchPoint.width || 25,
                height: touchPoint.height || 25,
                x: touchPoint.x || 20,
                y: touchPoint.y || 60,
                custom_icon: custom_icon,
                customIcon: custom_icon, // compatibility for preview component
                trueVideo: isVideoIcon, // mark for video rendering in html-preview
                angle: touchPoint.angle || 0
            };
        });

        return areas;
    }

    /**
     * Get video background for multi config preview
     * @returns {string}
     */
    getMultiConfigVideoBackground() {
        if (!this.deployment ||
            !this.deployment.multi_config ||
            !this.deployment.multi_config.background ||
            !this.deployment.multi_config.background.attachment_file) {
            return "";
        }

        const file = this.deployment.multi_config.background.attachment_file;
        return this.getFileType(file) === "mp4" ? file : "";
    }

    /**
     * Get video background for standby screen preview
     * @returns {string}
     */
    getMultiConfigStandByVideoBackground() {
        if (!this.deployment ||
            !this.deployment.multi_config ||
            !this.deployment.multi_config.standby_screen_image ||
            !this.deployment.multi_config.standby_screen_image.attachment_file) {
            return "";
        }

        const file = this.deployment.multi_config.standby_screen_image.attachment_file;
        return this.getFileType(file) === "mp4" ? file : "";
    }

    /**
     * Check background resolution for multi_config
     */
    checkBackgroundResolution() {
        setTimeout(() => {
            if (this.deployment &&
                this.deployment.multi_config &&
                this.deployment.multi_config.background &&
                this.deployment.multi_config.background.attachment_file) {

                let isVideo = this.deployment.multi_config.background.attachment_file.indexOf(".mp4") !== -1;
                const VALID_RESOLUTION = this.deployment.multi_config.screen_width / this.deployment.multi_config.screen_height;
                let media = isVideo ? new Video() : new Image();
                media.src = this.deployment.multi_config.background.attachment_file;

                if (isVideo) {
                    media.onloadeddata = () => {
                        if (media.videoWidth / media.videoHeight !== VALID_RESOLUTION) {
                            // Resolution mismatch - could show warning if needed
                        }
                    };
                } else {
                    media.onload = () => {
                        if (media.width / media.height !== VALID_RESOLUTION) {
                            // Resolution mismatch - could show warning if needed
                        }
                    };
                }
            }

            function Video() {
                return document.createElement("video");
            }
        });
    }

    addConfig() {
        // Add a new empty configuration slot
        if (!this.configurations) {
            this.configurations = [];
        }
        if (!this.configurations_info) {
            this.configurations_info = [];
        }

        const newIndex = this.configurations.length;
        this.configurations.push(null);
        this.selectedConfigsList[newIndex] = null;
        this.configsDropdownOpen[newIndex] = false;
        this.searchConfigs[newIndex] = "";

        // Ensure multi_config configs_info has placeholder
        if (!this.deployment.multi_config) {
            this.deployment.multi_config = {configurations_info: []};
        }
        if (!this.deployment.multi_config.configurations_info) {
            this.deployment.multi_config.configurations_info = [];
        }
        this.deployment.multi_config.configurations_info[newIndex] = {
            config_index: newIndex,
            width: 25,
            height: 25,
            x: 20 + (newIndex * 20),
            y: 60,
            custom_icon: null,
            angle: 0,
            id: null,
            url: null,
            name: null
        };

        // Initialize filtered list for the new dropdown
        // Use a copy of the full configs list
        if (this.configsList && this.configsList.length > 0) {
            this.filteredConfigsList[newIndex] = [...this.configsList];
        } else {
            this.filteredConfigsList[newIndex] = [];
            // If configs list is not loaded yet, ensure it gets loaded
            if (!this.configsList || this.configsList.length === 0) {
                this.getConfigs();
            }
        }
    }

    removeConfig(index) {
        if (!this.configurations || index < 0 || index >= this.configurations.length) {
            return;
        }

        // Clear timeout if exists
        if (this.searchTimeout[index] !== undefined) {
            clearTimeout(this.searchTimeout[index]);
        }

        // Remove configuration at the specified index
        this.configurations.splice(index, 1);

        // Remove from configurations_info if it exists
        if (this.configurations_info && this.configurations_info.length > index) {
            this.configurations_info.splice(index, 1);
        }

        // Remove touch point settings from multi_config.configurations_info
        if (this.deployment && this.deployment.multi_config && this.deployment.multi_config.configurations_info) {
            // Remove touch point for this index
            this.deployment.multi_config.configurations_info = this.deployment.multi_config.configurations_info.filter(tp => tp.config_index !== index);
            // Update config_index for remaining touch points (shift down)
            this.deployment.multi_config.configurations_info.forEach(tp => {
                if (tp.config_index > index) {
                    tp.config_index = tp.config_index - 1;
                }
            });
        }

        // Rebuild data structures to maintain proper indexing after removal
        const newSelectedConfigsList = [];
        const newConfigsDropdownOpen = {};
        const newSearchConfigs = {};
        const newFilteredConfigsList = {};
        const newSearchTimeout = {};

        // Rebuild arrays/objects with correct indices
        for (let i = 0; i < this.configurations.length; i++) {
            // For arrays, shift elements down
            if (i < index) {
                // Keep existing data for indices before the removed one
                newSelectedConfigsList[i] = this.selectedConfigsList[i] || null;
                if (this.configsDropdownOpen[i] !== undefined) {
                    newConfigsDropdownOpen[i] = this.configsDropdownOpen[i];
                }
                if (this.searchConfigs[i] !== undefined) {
                    newSearchConfigs[i] = this.searchConfigs[i];
                }
                if (this.filteredConfigsList[i] !== undefined) {
                    newFilteredConfigsList[i] = this.filteredConfigsList[i];
                }
            } else {
                // Shift data from next index to current index
                const sourceIndex = i + 1;
                newSelectedConfigsList[i] = this.selectedConfigsList[sourceIndex] || null;
                if (this.configsDropdownOpen[sourceIndex] !== undefined) {
                    newConfigsDropdownOpen[i] = this.configsDropdownOpen[sourceIndex];
                }
                if (this.searchConfigs[sourceIndex] !== undefined) {
                    newSearchConfigs[i] = this.searchConfigs[sourceIndex];
                }
                if (this.filteredConfigsList[sourceIndex] !== undefined) {
                    newFilteredConfigsList[i] = this.filteredConfigsList[sourceIndex];
                } else if (this.configsList && this.configsList.length > 0) {
                    // Initialize with full list if not exists
                    newFilteredConfigsList[i] = [...this.configsList];
                }
            }
        }

        // Update all data structures
        this.selectedConfigsList = newSelectedConfigsList;
        this.configsDropdownOpen = newConfigsDropdownOpen;
        this.searchConfigs = newSearchConfigs;
        this.filteredConfigsList = newFilteredConfigsList;
        this.searchTimeout = newSearchTimeout;

        // Trim multi_config configurations_info to match current configs length
        if (this.deployment && this.deployment.multi_config && this.deployment.multi_config.configurations_info) {
            this.deployment.multi_config.configurations_info = this.deployment.multi_config.configurations_info
                .filter(tp => tp.config_index < this.configurations.length)
                .map((tp, idx) => ({
                    ...tp,
                    config_index: idx
                }));
        }
    }
}

export default DeploymentUpdateController;



// WEBPACK FOOTER //
// ./sources/components/deployments/deployment-update/deployment-update.controller.js